<!--
@description dashBoard 时间范围选择
@author huangzhijie
@date 2018/11/22

@参数说明
// dash id
id 必须

@事件说明
// 点击时间，返回 type,format,startTime,endTime
time-range-click
// 文案改变
time-label-change
-->
-->
<style>
.time-range {
  margin-bottom: 16px;
}
.time-range__panel {
  padding: 10px;
  width: 800px;
  background: #F0F0F0;
}
/* .time-range__panel::before {
  content: " ";
  width: 0;
  height: 0;
  top: -8px;
  left: 50%;
  margin-left: -8px;
  position: absolute;
  border-left: 8px transparent solid;
  border-right: 8px transparent solid;
  border-bottom: 8px #F0F0F0 solid;
} */
.time-range__panel-head {
  color: #000;
  margin-bottom: 8px;
  font-size: 18px;
}
.time-range__panel-right {
  display: inline-block;
  width: 650px;
  height: 170px;
  vertical-align: top;
  line-height: 14px;
}
.time-range__text-btn {
  width: 100px;
  font-size: 14px;
  text-align: left;
  margin-right: 15px;
  padding: 6px;
  margin-left: 0 !important;
}
.time-range__panel-left {
  display: inline-block;
  width: 120px;
  vertical-align: top;
}
.time-range__panel-left-btn {
  height: 40px;
  margin-bottom: 10px;
  background: transparent;
  color: #000;
}
</style>
<template>
  <div class="time-range" v-show="isShowTime">
    <div class="vm time-range__panel">
      <div class="time-range__panel-left">
        <div class="time-range__panel-head">Time Range</div>
        <div>
          <el-button type="primary" 
            class="time-range__panel-left-btn" 
            :class="timeType === 'QUICK' ? 'is-active' : ''"
            @click="e_clickQuick" >Quick</el-button>
        </div>
        <div>
          <el-button 
            type="primary"
            class="time-range__panel-left-btn"
            :class="timeType === 'ABSOLUTE' ? 'is-active' : ''"
            @click="e_clickAbsolute">Absolute</el-button>
        </div>
      </div>
      <div class="time-range__panel-right">
        <div v-show="timeType === 'QUICK'">
          <el-button v-for="(item, key) in timeList" :key="key" 
            class="time-range__text-btn" 
            type="text" 
            @click="e_clickTime(key)">{{ item }}</el-button>
        </div>
        <div v-show="timeType === 'ABSOLUTE'" style="margin-top: 60px;">
          <el-form ref="form" :inline="true" label-width="150" input-width="auto">
            <el-form-item :label="$t('common.time')">
              <el-date-picker
                v-model="form.startTime"
                type="datetime"
                value-format="timestamp">
              </el-date-picker>
              {{$t('common.to')}}
              <el-date-picker
                v-model="form.endTime"
                type="datetime"
                value-format="timestamp">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="e_search">{{ $t('common.search') }}</el-button>
            </el-form-item>
          </el-form>   
        </div>
      </div>       
    </div>
  </div>
</template>
<script>
import dic from '@/components/mixins/dic'
import DashBoardBiz from '@/logic/intelligentMonitor/dashBoardBiz'
import TimeFormat from '@/utils/timeFormat'

const TIME_TYPE = {
  QUICK: 'QUICK',
  ABSOLUTE: 'ABSOLUTE'
}

export default {
  mixins: [dic],
  data () {
    return {
      timeType: TIME_TYPE.QUICK,
      timeLabel: '',
      timeList: {},
      timeQuickFormat: '',
      form: {
        startTime: TimeFormat.getToday(),
        endTime: new Date().getTime()
      }
    }
  },
  computed: {
    isShowTime () {
      return this.show
    }
  },
  props: {
    id: {
      type: String,
      require: true
    },
    type: {
      type: String,
      default () {
        return TIME_TYPE.QUICK
      }
    },
    data: {
      type: Object,
      default () {
        return {
          format: 'Today'
        }
      }
    },
    show: {
      type: Boolean
    }
  },
  watch: {
    'type': function (val) {
      this.timeType = val
    },
    'data': function (val) {
      if (val && val.format) {
        this.setTimeLabel({
          type: this.timeType,
          formatKey: val.format
        })
      } else if (val && val.startTime && val.endTime) {
        this.form.startTime = val.startTime
        this.form.endTime = val.endTime
        this.setTimeLabel({
          type: this.timeType,
          startTime: val.startTime,
          endTime: val.endTime
        })
      }
    }
  },
  methods: {
    init () {
      this.timeType = this.type
      this.setTimeList()
    },
    async setTimeList () {
      if (Object.keys(this.timeList).length > 0) return
      await this.dGetDictionaryByCode('quicktimetype')
      this.timeList = this.dDictionary.quicktimetype
    },
    async setTimeLabel ({type, startTime, endTime, formatKey}) {
      if (type === TIME_TYPE.QUICK) {
        if (Object.keys(this.timeList).length === 0) {
          await this.setTimeList()
        }
        this.timeLabel = this.timeList[formatKey]
      } else {
        this.timeLabel = `${TimeFormat.getFormatTime(startTime)} to ${TimeFormat.getFormatTime(endTime)}`
      }
      this.$emit('time-label-change', {
        label: this.timeLabel
      })
    },
    e_clickQuick () {
      this.timeType = TIME_TYPE.QUICK
    },
    e_clickAbsolute () {
      this.timeType = TIME_TYPE.ABSOLUTE
    },
    e_clickTime (item) {
      DashBoardBiz.getAbsoluteTime({
        dashId: this.id,
        type: this.timeType,
        data: {
          format: item
        }
      }).then((d) => {
        this.setTimeLabel({type: this.timeType, formatKey: item})
        this.$emit('time-range-click', {
          type: this.timeType,
          format: item,
          startTime: d.startTime,
          endTime: d.endTime
        })
      })
    },
    e_search () {
      const startTime = this.form.startTime
      const endTime = this.form.endTime

      DashBoardBiz.getAbsoluteTime({
        dashId: this.id,
        type: this.timeType,
        data: {
          startTime: startTime,
          endTime: endTime
        }
      }).then((d) => {
        this.setTimeLabel({type: this.timeType, startTime, endTime})
        this.$emit('time-range-click', {
          type: this.timeType,
          startTime: d.startTime,
          endTime: d.endTime
        })
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>